// eslint-disable-next-line no-restricted-imports
import { createInstance, setLogLevel } from '@optimizely/react-sdk'

import { FlagReactForcedDecisions, FlagReactInstanceType } from './types'

type CreateFlagInstanceType = typeof createInstance
export type CreateFlagInstanceConfigType =
  Parameters<CreateFlagInstanceType>[0] & {
    appVersion: string
    forcedDecisions?: FlagReactForcedDecisions
  }

export const createFlagInstance = ({
  appVersion,
  forcedDecisions,
  ...opts
}: CreateFlagInstanceConfigType) => {
  const instance = createInstance({
    ...opts,
    datafileOptions: {
      autoUpdate: true,
      updateInterval: 5 * 60000, // in milliseconds
      urlTemplate: `https://features.surglogs.com/%s.json?version=${appVersion}`,
      ...(opts.datafileOptions || {}),
    },
  }) as FlagReactInstanceType

  instance.forcedDecisions = forcedDecisions

  setLogLevel('warn')

  return instance
}
